export const desktopPixelSize = 1000;

export const MOBILE_HEADER_HEIGHT = 80;

export const LOADER_DELAY_TIME = 10;
